export default __webpack_public_path__ + "static/media/A-graphic-extrasmall.699fba7f.svg";